function product_desc_based_on_price () {
      // console.log('bhayo');
      var currentVariant = window.location.search.split('variant=')[1];
      // console.log(currentVariant);
      var i;
      for (i = 0; i < variants.length; i++) {
        if (variants[i][0] == currentVariant){
          var currentVariantPrice = variants[i][1];
          var currentVariantAvailability = (variants[i][2] === "true");

          // console.log(currentVariantPrice/100);

          if (typeof instoreboolean == 'undefined') {


            if((currentVariantPrice/100) < 150){
              document.querySelector("#add-to-cart-button").setAttribute("style","display:none !important;");
              document.querySelector("#Enquire-button").setAttribute("style","display:block !important;");
              // console.log("Enquire");
            }else{
              document.querySelector("#add-to-cart-button").setAttribute("style","display:block !important;");
              document.querySelector("#Enquire-button").setAttribute("style","display:none !important;");
              // console.log("add");
            }
          }else{
            document.querySelector("#add-to-cart-button").setAttribute("style","display:none !important;");
            document.querySelector("#Enquire-button").setAttribute("style","display:block !important;");
            // console.log("Enquire");
          }

          if (document.querySelector("#freeShippingBlock")!==null){
            if(currentVariantAvailability){
              if((currentVariantPrice/100) < 250){
                // console.log("Av and <250")
                document.querySelector("#freeShippingBlock > ul").setAttribute("style","display:none !important;");
                document.querySelector("#returnDaysBlock").setAttribute("style","margin-top:25px; !important");
              }else{
                // console.log("Av and >250")
                document.querySelector("#freeShippingBlock > ul").setAttribute("style","display:block !important;");
                document.querySelector("#returnDaysBlock").setAttribute("style","");
              }
            }else{
              // console.log("not AV")
              document.querySelector("#freeShippingBlock > ul").setAttribute("style","display:none !important;");
              document.querySelector("#returnDaysBlock").setAttribute("style","margin-top:25px; !important");
            }
          }
        }
      }
  }

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready

    // Free shipping tick on product page based on price
    document.querySelector('div[data-product-blocks]').addEventListener('change', product_desc_based_on_price);
  });